module.exports = __webpack_public_path__ + "static/media/authentication.dc4bc5e4.svg";